import {
  OneTimeProduct,
  Product,
  ProductPrice,
  ProductsWithMedicationForm,
} from "../types";
import { patientApi } from "./patientApi";

export const productsApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    //products
    getProductPrices: builder.query<
      ProductPrice[],
      {
        product: string;
        stripe_id?: string;
        product_variant?: string;
        visit?: string;
        active: boolean;
      }
    >({
      query: (params) => ({
        method: "GET",
        url: `/api/patient/prices`,
        params,
      }),
    }),
    getProductBySlug: builder.query<Product, string>({
      query: (productSlug) => ({
        method: "GET",
        url: `/api/products/${productSlug}`,
      }),
    }),
    getOneTimeProductsBySlug: builder.query<
      OneTimeProduct[],
      { slug: string; number_of_months?: number }
    >({
      query: ({ slug, number_of_months }) => ({
        method: "GET",
        url: `/api/products/one-time/${slug}/${number_of_months}-month`,
      }),
    }),
    getProducts: builder.query<Product[], void>({
      query: () => ({
        method: "GET",
        url: `/api/products`,
      }),
    }),
    getProductsWithMedications: builder.query<
      ProductsWithMedicationForm[],
      {
        gender: string;
        category?: string;
      }
    >({
      query: ({ gender, category }) => ({
        method: "GET",
        url: `/api/products/favorites/${gender}`,
        params: {
          category,
        },
      }),
    }),
    getProductVariantPrices: builder.query<
      ProductPrice[],
      { slug: string; product_slug: string }
    >({
      query: ({ slug, product_slug }) => ({
        url: `/api/products/${product_slug}/variants/${slug}/prices`,
      }),
    }),
  }),
});

export const {
  useGetProductPricesQuery,
  useGetProductBySlugQuery,
  useGetOneTimeProductsBySlugQuery,
  useGetProductsQuery,
  useGetProductsWithMedicationsQuery,
  useGetProductVariantPricesQuery,
} = productsApi;
